import React, { useContext, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { latestDate } from "../../../../sharedComponent/common";
import CommonDatePicker from "../../../../sharedComponent/CommonDatePicker";
import Import from "../../../../assets/images/ic-Import.svg";
import ApiConfig from "../../../../api/ApiConfig";
import { getWithAuthCall, simplePostCall } from "../../../../api/ApiServices";
import Loader from "../../../../sharedComponent/Loader";
import NoDataComp from "../../../../sharedComponent/NoDataComp";
import { Select } from "antd";

const { Option } = Select;

const MonthlyDeviceUptimeReport = () => {
  const { sidebar } = useContext(AppContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [VehicleId, setVehicleId] = useState("");
  const [monthDate, setMonthDate] = useState({ toDayDate: new Date() });
  const [OptionDownload, setOptionDownload] = useState("");
  const [OrderListData, setOrderListData] = useState([]);
  const maxDate = new Date();

  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  useEffect(() => {
    getVehicleList();
  }, []);

  function getVehicleList() {
    getWithAuthCall(ApiConfig.VEHICEL_AVALIVALITY_DROPDAWAN)
      .then((data) => setVehicleList(data?.data || []))
      .catch((err) => console.log("api err", err));
  }

  useEffect(() => {
    fetchReport();
  }, [VehicleId, monthDate, OptionDownload]);

  /* === GREEN :: API INTEGRATED === */
  const fetchReport = () => {
    const body = {
      format: OptionDownload,
      vehicle_id: VehicleId,
      report_date: latestDate(monthDate.toDayDate, "yyyy-MM-dd"),
    };
    setLoading(true);
    setOptionDownload("");
    simplePostCall(
      ApiConfig.MONTHLY_DEVICE_UPTIME_REPORT,
      JSON.stringify(body)
    )
      .then((res) => {
        if (res?.result) {
          const allDetails = res?.all_vehicle_details || {};
          const mapped = Object.entries(allDetails).map(([imei, val]) => ({
            vehicle_imei: imei,
            vehicle_number: val?.vehicle_number,
            device_type: val?.device_type,
            track_duration: val?.track_duration,
            uptime_percentage: val?.uptime_percentage,
          }));
          setOrderListData(mapped);
        } else {
          setOrderListData([]);
        }
      })
      .catch((err) => console.log("Error:", err))
      .finally(() => setLoading(false));
  };

  return (
    <motion.div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
      variants={aninations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1 }}
    >
      <div id="cx-wrapper" className="Vehicle_inspition_dashboard heightFixed">
        <div className="report-viwe-head" id="Viwe_Report_Respoasive">
          <p></p>
        </div>

        <div className="col-lg-12 mt-0">
          <div className="UserTabel">
            <div className="heading">
              <div>
                <p>
                  <p>
                    {t("Month:")}{" "}
                    {monthDate.toDayDate.toLocaleString("en-US", {
                      month: "long",
                      year: "numeric",
                    })}
                  </p>
                </p>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "180px" }}
                  className="custom-select"
                  placeholder={t("Vehicle list")}
                  onChange={(value) => setVehicleId(value)}
                  showSearch
                  filterOption={(input, option) =>
                    option?.label?.toString().toLowerCase().includes(input.toLowerCase())
                  }
                  optionFilterProp="label"
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Vehicle")}
                  </Option>
                  {vehicleList?.map((vehicle) => (
                    <Option
                      key={vehicle.vehicle_id}
                      value={vehicle.vehicle_id}
                      label={vehicle.vehicle_number}
                      style={{ color: "rgba(156, 73, 0)" }}
                    >
                      {vehicle.vehicle_number}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="innerSelectBox weekCounter datepicker-main">
                <CommonDatePicker
                  dateKey={"toDayDate"}
                  setDate={setMonthDate}
                  data={monthDate}
                  SetPlaceholder={t("Select Month")}
                  dataDisbal={maxDate}
                />
              </div>

              <div className="right-export-btn-section-wrapper">
                <div className="md_dropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <img src={Import} alt="" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("pdf")} className="d-block">
                          {t("PDF")}
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("excel")} className="d-block">
                          {t("Excel")}
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            {/* === GREEN :: API INTEGRATED (table fields mapped to API response) === */}
            <table className="table tableAdmin">
              <thead className="tableHead">
                <tr className="text-center">
                  <th>{t("Sr No")}</th>
                  <th>{t("Vehicle Number")}</th>
                  <th>{t("Device IMEI")}</th>
                  <th>{t("Device Type")}</th>
                  <th>{t("Total Uptime Duration")}</th>
                  <th>{t("Uptime Percentage")}</th>
                </tr>
              </thead>
              {loading ? (
                <Loader />
              ) : (
                <tbody className="tableBody">
                  {OrderListData && OrderListData?.length > 0
                    ? OrderListData.map((item, index) => (
                        <tr className="text-center" key={index}>
                          <td>{index + 1}</td>
                          <td>{item.vehicle_number}</td>
                          <td>{item.vehicle_imei}</td>
                          <td>{item.device_type}</td>
                          <td>{item.track_duration}</td>
                          <td>{item.uptime_percentage}</td>
                        </tr>
                      ))
                    : null}
                </tbody>
              )}
            </table>

            {OrderListData?.length === 0 && !loading && <NoDataComp />}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default MonthlyDeviceUptimeReport;
